// extracted by mini-css-extract-plugin
module.exports = {"root":"f-virtual-list_1WaM6for"};